"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Option = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _BodyOption = require("./components/BodyOption");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Option = function Option(props) {
  var data = props.data;
  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, props, /*#__PURE__*/_react["default"].createElement(_BodyOption.BodyOption, data));
};

exports.Option = Option;